import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../commonComponents/modal/Modal';
import translate from '../../../commonComponents/translate';
import FormNewRecommendation from './Components/FormNewRecommendation';
import UserProp from '../../../commonComponents/propTypes/userProp';

function AddRecommendationModal({ t, onClose, recommendation, user }) {
  const NewRec = () => (
      <FormNewRecommendation
        t={t}
        recommendation={recommendation}
      />
    );
  const [inputList, setInputList] = useState([]);

  const onAddBtnClick = () => {
    setInputList(inputList.concat(<NewRec />));
  };

  return (
    <Modal onClose={onClose}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div id="modalBody" className="modal-body recommendation-modal" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <div className="recommendation-participant">
              <img
                src={user.image
                && user.image
                  ? user.image.thumb
                  : '/images/no_user.png'}
                alt={`${user.firstName} ${user.lastName}`}
              />
              <span className="recommendation-participant_name">
                 {`${user.firstName} ${user.lastName}`}
              </span>
            </div>
            <h5>
              {t('sessionDetails_modal.titleRec')}
            </h5>
            <FormNewRecommendation
              t={t}
              recommendation={recommendation}
            />
            {inputList}
            <div className="sessionDetail_add-participant">
              <button
                type="button"
                onClick={onAddBtnClick}
                className="btn m-btn--pill btn-metal navigation-button"
              >
                <i className="fa fa-plus" />
              </button>
              <span style={{ alignSelf: 'center', marginLeft: '1rem' }}>
                {t('sessionDetails_modal_addNewRecommendation')}
              </span>
            </div>
            <div className="modal-buttons">
              <div className="row justify-content-end">
                <div className="col-3 button-cancel">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                  >
                    {t('sessionDetails_modal_cancel')}
                  </button>
                </div>
                <div className="col-4">
                  <button type="button" className="btn btn-dynamic">
                    {t('sessionDetails_modal_makeRecommendation')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

AddRecommendationModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  recommendation: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
  user: PropTypes.shape(UserProp.propType).isRequired,
};
AddRecommendationModal.defaultProps = {
  onClose: () => {},
  recommendation: {
    firstName: '',
    lastName: '',
    email: '',
  },
};

export default translate(AddRecommendationModal);
